const humps = require('../../../utils/humps');

const _defaultMenus = require('./default-menus.json');
const AddToAssetsView = require('./dropdown/add-to-assets');
const BulletPointsView = require('./dropdown/edit-bullet-points');
const CellAlignmentView = require('./dropdown/edit-cell-alignment');
const CellBorderView = require('./dropdown/edit-cell-border');
const CellFontView = require('./dropdown/edit-cell-font');
const OrderedListView = require('./dropdown/edit-ordered-list');
const HeaderAndFooterConfigurationView = require('./dropdown/header-and-footer-configuration');
const LinkDropdownView = require('./dropdown/link');
const TextLinkView = require('./dropdown/text-link');
const PopupMenuCommonFunctions = require('./popupmenu-common-functions');
const PopupMenuElementItemsDrawer = require('./popupmenu-element-items-drawer');
const PopupMenuEvents = require('./popupmenu-events');

module.exports = Backbone.View.extend({
  defaultMenus: _defaultMenus,

  initialize: function () {
    _.bindAll(this, 'buildPopupMenu');
    this.popupMenuEvents = new PopupMenuEvents();
    this.popupMenuCommonFunctions = new PopupMenuCommonFunctions();
    this.editor = INKIVE.Tool.getInstance().editor;

    if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE) {
      this.defaultMenus.TEXT.unshift('PERMISSIONS');
      this.defaultMenus.TABLE.unshift('PERMISSIONS');
      this.defaultMenus.LOGO.unshift('PERMISSIONS');
      this.defaultMenus.ICON.unshift('PERMISSIONS');
      this.defaultMenus.VIDEO.unshift('PERMISSIONS');
      this.defaultMenus.IMAGE.unshift('PERMISSIONS');
      this.defaultMenus.STICKER.unshift('PERMISSIONS');
      this.defaultMenus.DEFAULT.unshift('PERMISSIONS');
      this.defaultMenus.BACKGROUND.unshift('PERMISSIONS');
    }
  },

  buildPopupMenu: function (elem, menuId, multiselectMenuIds, $el) {
    this.$elem = $(elem);

    if (INKIVE.C.IS_MOBILE_APP) {
      return;
    }

    // For multiselect toolbar, get the common buttons that are defined for all item types
    if (menuId === 'multiselect') {
      let multiselectButtons = [];
      for (let i = 0; i < multiselectMenuIds.length; i++) {
        const buttonGroupName = multiselectMenuIds[i] === 'misc' ? 'DEFAULT' : multiselectMenuIds[i].toUpperCase();
        if (i === 0) {
          multiselectButtons = this.defaultMenus[buttonGroupName];
        } else {
          multiselectButtons = multiselectButtons?.filter?.(button => this.defaultMenus[buttonGroupName]?.includes?.(button));
        }
      }
      this.defaultMenus.MULTISELECT = multiselectButtons;
    }

    this.buttonSelect = _.bind(this.$elem.popupmenu, this.$elem, 'button');

    this.popupMenuElementItemsDrawer = new PopupMenuElementItemsDrawer(
      this.$elem, this.buttonSelect,
      this.popupMenuCommonFunctions,
      this.defaultMenus);

    if (['text', 'table', 'video', 'logo', 'icon', 'layout', 'image', 'sticker', 'group',
      'multiselect', 'background', 'root', 'bleed', 'locked', 'headerAndFooter', 'qrcode'].includes(menuId)) {
      this.popupMenuElementItemsDrawer['draw' + humps.pascalize(menuId) + 'MenuItems']();
    } else {
      this.popupMenuElementItemsDrawer.drawDefaultMenuItems(menuId);
    }

    if (!this.$elem.popupmenu('menu')) {
      return false;
    }

    this.$elem.popupmenu('menu').find('.ui-dropdown').popupmenudropdown({
      onShow: function () {
        const $button = $(this).parent();
        if (this.dataset.display) {
          this.style.display = this.dataset.display;
        }

        $button.is('[data-action="on_fontfamily"]') && $button.trigger('fonts-shown');
      }
    });

    if (!this.$elem.is('#svgroot') && !this.$elem.is('#clip_bleed_area')) {
      this.popupMenuCommonFunctions.initSliderElement(
        this.$elem.popupmenu('button', 'on_opacity'),
        'opacity', parseInt(this.editor.getOpacity() * 100), 0, 100
      );

      this.popupMenuCommonFunctions.drawStrokeDropdownItems(this.$elem);

      this.initColors(elem);
      this.initLinks(elem);
      this.initAddToLibrary(elem);
      this.initCellAlignment(elem);
      this.initCellBorder(elem);
      this.initCellFont(elem);
      this.initBulletPoints(elem);
      this.initOrderedList(elem);
      this.initTextLink(elem);
      this.initHeaderAndFooterConfiguration(elem);

      this.popupMenuCommonFunctions.handleAlignmentOptions($el[0].querySelector('a[data-action="on_arrange"] div.ui-dropdown-div'));
    }

    this.popupMenuEvents.loadEvents(elem);
    this.popupMenuCommonFunctions.highlightAppliedOptions(this.buttonSelect, this.$elem);

    $el.find('.element-popupmenu').css('display', this.$elem.is('#svgroot') ? 'none' : 'flex');
    $el.find('.root-popupmenu').css('display', this.$elem.is('#svgroot') ? 'flex' : 'none');

    this.editor.canvas.runExtensions('browserResize', {});
    $el.find('.scroll-handler i').on('click', this.popupMenuCommonFunctions.scrollHandler);
  },

  initColors: function (elem) {
    this.$elem.popupmenu('button', 'colormap-circle')
      .find('.ui-dropdown-items')
      .each(_.partial(this.popupMenuCommonFunctions.drawColor, elem));
  },

  initLinks: function (elem) {
    const $linkDropdown = this.$elem.popupmenu('button', 'on_linkElement')
      .find('.ui-dropdown-items');

    const $unLinkDropdown = this.$elem.popupmenu('button', 'on_unlinkElement')
      .find('.ui-dropdown-items');

    if ($linkDropdown.length || $unLinkDropdown.length) {
      const linkElement = elem.tagName === 'a' ? elem : undefined;

      /* eslint-disable no-new */
      new LinkDropdownView({
        el: $linkDropdown.length ? $linkDropdown : $unLinkDropdown,
        href: linkElement && svgedit.utilities.getHref(linkElement),
        canvas: this.editor.canvas
      });
    }
  },

  initAddToLibrary: function (elem) {
    const $addToLibraryDropdown = this.$elem.popupmenu('button', 'on_library_add')
      .find('.ui-dropdown-items');

    if ($addToLibraryDropdown.length) {
      /* eslint-disable no-new */
      new AddToAssetsView({
        el: $addToLibraryDropdown,
        selectedElement: elem
      });
    }
  },

  initCellAlignment: function (elem) {
    const $cellAlignmentDropdown = this.$elem.popupmenu('button', 'on_edit-cell-alignment')
      .find('.ui-dropdown-items');

    if ($cellAlignmentDropdown.length) {
      /* eslint-disable no-new */
      new CellAlignmentView({
        el: $cellAlignmentDropdown,
        selectedElement: elem
      });
    }
  },

  initCellBorder: function (elem) {
    const $cellBorderDropdown = this.$elem.popupmenu('button', 'on_edit-cell-border')
      .find('.ui-dropdown-items');

    if ($cellBorderDropdown.length) {
      /* eslint-disable no-new */
      new CellBorderView({
        el: $cellBorderDropdown,
        selectedElement: elem,
        canvas: this.editor.canvas,
        popupMenuCommonFunctions: this.popupMenuCommonFunctions
      });
    }
  },

  initCellFont: function (elem) {
    const $cellFontDropdown = this.$elem.popupmenu('button', 'on_edit-cell-font')
      .find('.ui-dropdown-items');

    if ($cellFontDropdown.length) {
      /* eslint-disable no-new */
      new CellFontView({
        el: $cellFontDropdown,
        selectedElement: elem
      });
    }
  },

  initOrderedList: function (elem) {
    const $orderedListDropdown = this.$elem.popupmenu('button', 'on_set-list')
      .find('.ui-dropdown-items');

    if ($orderedListDropdown.length) {
      /* eslint-disable no-new */
      new OrderedListView({
        el: $orderedListDropdown,
        selectedElement: elem
      });
    }
  },

  initBulletPoints: function (elem) {
    const $bulletPointsDropdown = this.$elem.popupmenu('button', 'on_set-bullets')
      .find('.ui-dropdown-items');

    if ($bulletPointsDropdown.length) {
      /* eslint-disable no-new */
      new BulletPointsView({
        el: $bulletPointsDropdown,
        selectedElement: elem
      });
    }
  },

  initTextLink: function (elem) {
    const $textLinkDropdown = this.$elem.popupmenu('button', 'on_set-link')
      .find('.ui-dropdown-items');

    if ($textLinkDropdown.length) {
      const aTag = elem.tagName === 'a' ? elem : elem.querySelector('a');
      /* eslint-disable no-new */
      new TextLinkView({
        el: $textLinkDropdown,
        canvas: this.editor.canvas,
        href: aTag && svgedit.utilities.getHref(aTag),
        selectedElement: elem
      });
    }
  },

  initHeaderAndFooterConfiguration: function (elem) {
    const $container = this.$elem.popupmenu('button', 'on_HeaderAndFooterPageSettings')
      .find('.ui-dropdown-items');

    if ($container.length) {
      new HeaderAndFooterConfigurationView({
        el: $container,
        selectedElement: elem
      });
    }
  }

});
